import { jsx } from "react/jsx-runtime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { validateTidalLicense } from "../../base/index.js";
function LocationOn(props) {
  return /* @__PURE__ */ jsx(
    LocationOnIcon,
    {
      "data-testid": "LocationOn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LocationOn",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
LocationOn.tidalIconMeta = {
  categories: "map,location,time",
  name: "LocationOn"
};
validateTidalLicense();
export {
  LocationOn
};
//# sourceMappingURL=LocationOn.js.map
